import { getDownload } from '../services/api';

interface UseIjrrDownloadOptions {
  selected: { [key: string]: string[] };
  userEmail?: string;
  format?: 'IJRR' | 'MCAP';
}

export function useIjrrDownload({
  selected,
  userEmail,
  format = 'IJRR',
}: UseIjrrDownloadOptions) {
  const handleBashScript = () => {
    const url = getDownload(selected, userEmail, format);
    const a = document.createElement('a');
    a.href = url;
    document.body.appendChild(a);
    a.click();
    a.remove();
  };

  return { handleBashScript };
}
